<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6" lg="6">
        <b-card header="Welcome">
          <div>
            <p>Welcome to your Account Administration System. Using the menu items to the left and above, you can perform the following functions:</p>
            <li>Review used access codes (who has completed tests and when)</li>
            <li>Generate reports for used access codes in the language of your choice</li>
            <li>Manage demographic variables collected during testing</li>
            <li>Manage individuals and email addresses for receiving reports</li>
          </div>
        </b-card>
      </b-col>
      <b-col sm="6" lg="6">
        <b-card header="Quick Search Tools">
          <el-form :inline="true" @submit.native.prevent size="mini" label-position="right">
            <el-form-item label="Name:" prop="emailSubject">
              <el-input
                v-model="search.name"
                width="140"
                placeholder="e.g. Chris Smith"
                @keyup.enter.native="searchByName"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchByName">Find</el-button>
            </el-form-item>
          </el-form>
          <!-- Seach by Code -->
          <el-form :inline="true" @submit.native.prevent size="mini" label-position="right">
            <el-form-item label="Code:" prop="emailSubject">
              <el-input
                v-model="search.code"
                placeholder="e.g. 1X2FEFEI"
                @keyup.enter.native="searchByCode"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchByCode">Find</el-button>
            </el-form-item>
          </el-form>
          <el-alert v-if="codeNotFound" title="Code couldn't be found" type="warning"></el-alert>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="isDistributor && !isEmulated">
      <b-col sm="12" lg="6">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <h4 class="mb-0">0</h4>
            <p>Client Active Test-Takers (24 hrs)</p>
          </b-card-body>
          <card-line1-chart-example
            chartId="card-chart-01"
            class="chart-wrapper px-3"
            style="height:70px;"
            :height="70"
          />
        </b-card>
      </b-col>
      <b-col sm="12" lg="6">
        <b-card no-body class="bg-info">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{getDistributorRecentlyCompletedCount}}</h4>
            <p>Client Reports (14 days)</p>
          </b-card-body>
          <card-line2-chart-example
            chartId="card-chart-02"
            class="chart-wrapper px-3"
            style="height:70px;"
            :height="70"
          />
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <!-- -->
      <b-col sm="12" lg="6">
        <b-card no-body class="bg-warning">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{ getActiveCount }}</h4>
            <p>Your Active Test-takers (24 hrs)</p>
          </b-card-body>
          <card-test-takers-online
            chartId="card-chart-03"
            class="chart-wrapper"
            style="height:70px;"
            height="70"
          />
        </b-card>
      </b-col>
      <b-col sm="12" lg="6">
        <b-card no-body class="bg-danger">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{getRecentlyCompletedCount}}</h4>
            <p>Your Reports (14 days)</p>
          </b-card-body>
          <card-reports-generated
            chartId="card-chart-04"
            class="chart-wrapper px-3"
            style="height:70px;"
            height="70"
          />
        </b-card>
      </b-col>
    </b-row>
    <div v-if="isDistributor && !isEmulated" class="text-center">
      <el-radio-group v-model="recentType">
        <el-radio-button label="Client Recent"></el-radio-button>
        <el-radio-button label="Your Recent"></el-radio-button>
      </el-radio-group>
    </div>
    <div>
      <b-card
        v-if="recentType === 'Your Recent'"
        class="animated fadeIn"
        :header="'Recently Completed'"
      >
        <el-table v-loading="loading" :data="getRecentCompletedList">
          <el-table-column prop="code" sortable label="Code" width="120"></el-table-column>
          <el-table-column prop="fullname" sortable label="Name">
            <template slot-scope="scope">
              <router-link :to="'/user/' + scope.row.id">{{ scope.row.fullname}}</router-link>
            </template>
          </el-table-column>
          <el-table-column prop="package" sortable label="Package"></el-table-column>
          <el-table-column prop="instrument" sortable label="Instrument"></el-table-column>
          <el-table-column label="Date">
            <template slot-scope="scope">
              <i class="el-icon-time"></i>
              <span style="margin-left: 10px">{{ formatDate(scope.row.completionDate) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Operations" width="120">
            <template slot-scope="scope">
              <el-button size="mini" @click="viewProfile(scope.$index, scope.row)">View</el-button>
            </template>
          </el-table-column>
        </el-table>
      </b-card>
    </div>
    <div>
      <b-card
        v-if="recentType === 'Client Recent'"
        class="animated fadeIn"
        :header="'Client Recently Completed'"
      >
        <el-table v-if="isDistributor && !isEmulated" :data="getDistributorRecentlyCompleted">
          <el-table-column prop="company" sortable label="Client" width="120"></el-table-column>
          <el-table-column prop="username" sortable label="Code" width="120"></el-table-column>
          <el-table-column prop="fullname" sortable label="Name">
            <template slot-scope="scope">
              <router-link
                :to="'/user/' + scope.row.general_id"
              >{{ scope.row.first_name + ' ' + scope.row.last_name}}</router-link>
            </template>
          </el-table-column>
          <el-table-column prop="package_name" sortable label="Package"></el-table-column>
          <el-table-column prop="verbose_name" sortable label="Instrument"></el-table-column>
          <el-table-column label="Date">
            <template slot-scope="scope">
              <i class="el-icon-time"></i>
              <span style="margin-left: 10px">{{ formatDate(scope.row.completion_time) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Operations" width="120">
            <template slot-scope="scope">
              <el-button size="mini" @click="viewClientProfile(scope.$index, scope.row)">View</el-button>
            </template>
          </el-table-column>
        </el-table>
      </b-card>
    </div>
  </div>
</template>
<script>
import axios from '../../shared/axios.js';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import CardLine1ChartExample from '../dashboard/CardDistributorTestTakersOnline';
import CardLine2ChartExample from '../dashboard/CardDistributorReportsGenerated';
import CardTestTakersOnline from '../dashboard/CardTestTakersOnline';
import CardReportsGenerated from '../dashboard/CardReportsGenerated';
import MainChartExample from '../dashboard/MainChartExample';
import SocialBoxChartExample from '../dashboard/SocialBoxChartExample';
import CalloutChartExample from '../dashboard/CalloutChartExample';
import { Callout } from '@coreui/vue';

export default {
  name: 'dashboard',
  computed: {
    ...mapGetters('auth', [
      'getCompanyName',
      'getDistributorName',
      'isDistributor',
      'isEmulated'
    ]),
    ...mapGetters('recent', ['getRecentCompletedList']),
    ...mapGetters('dashboard', [
      'getActiveCount',
      'getRecentlyCompletedCount',
      'getDistributorRecentlyCompletedCount',
      'getDistributorRecentlyCompleted'
    ]),
    ...mapGetters('settings', ['getSettings'])
  },
  components: {
    Callout,
    CardLine1ChartExample,
    CardLine2ChartExample,
    CardTestTakersOnline,
    CardReportsGenerated,
    MainChartExample,
    SocialBoxChartExample,
    CalloutChartExample
  },
  data: function() {
    return {
      loading: false,
      search: {
        name: '',
        code: ''
      },
      codeNotFound: false,
      recentType: 'Your Recent'
    };
  },
  created() {
    this.loading = true;
    const c = [];
    c.push(this.fetchClientSettings());
    c.push(this.fetchRecentlyCompleted());
    if (this.isDistributor && !this.isEmulated) {
      c.push(this.fetchDistributorRecentlyCompleted());
    }
    Promise.all(c).then(r => {
      this.loading = false;
    });
  },
  methods: {
    ...mapActions('recent', ['fetchRecentlyCompleted']),
    ...mapActions('settings', ['fetchClientSettings']),
    ...mapActions('dashboard', [
      'fetchActiveUsers',
      'fetchDistributorRecentlyCompleted'
    ]),
    viewProfile(index, row) {
      this.$router.push('/user/' + row.id);
    },
    viewClientProfile(index, row) {
      this.$router.push('/user/' + row.general_id);
    },
    formatDate(input) {
      return moment(input).format('M/D/YYYY h:mm a zz');
    },
    searchByCode() {
      axios.get('search/code/' + this.search.code).then(r => {
        // console.log(r);
        if (r.data.exists) {
          const id = r.data.results;
          this.$router.push('/user/' + id);
        } else {
          this.codeNotFound = true;
        }
      });
    },
    searchByName() {
      this.$router.push('/search/' + this.search.name);
    }
  }
};
</script>
